import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as api from "../../services/admin.service";

export const getHunterCompanyThunk = createAsyncThunk(
  "marketing/GET_HUNTER_COMPANY",
  async (keyword: string, { rejectWithValue }) => {
    try {
      const response = await api.getHunterCompany(keyword);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const getHunterEmployeeThunk = createAsyncThunk(
  "marketing/GET_HUNTER_EMPLOYEE",
  async (company: string, { rejectWithValue }) => {
    try {
      const response = await api.getHunterEmployee(company);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export const createNotificationThunk = createAsyncThunk(
  "marketing/CREATE_NOTIFICATION",
  async ({ title, body }: { title: string; body: string }, { rejectWithValue }) => {
    try {
      const response = await api.createNotification(title, body);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);